import React, { useState } from "react";
import { Button, Field, Input } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { showToast } from "#root/components/GlobalToaster";
import ButtonGroup from "#root/components/ButtonGroup";
import { ROUTES } from "#root/routes/constants";
import { useCreateSuperAdmin } from "#root/queries/superAdmin";
import { VALIDATION_PATTERNS, VALIDATION_MESSAGES } from "#root/utils/validation";
import SuperAdminForm from "../SuperAdminForm";

interface SuperAdminFormData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
}

const initialFormData: SuperAdminFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
};

const CreateSuperAdmin: React.FC = () => {
  const navigate = useNavigate();
  const createSuperAdminMutation = useCreateSuperAdmin();

  const [formData, setFormData] = useState<SuperAdminFormData>(initialFormData);
  const [errors, setErrors] = useState<Record<string, string>>({});
   const [passwordManual, setPasswordManual] = useState(true);
  const handleInputChange = (field: keyof SuperAdminFormData, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handlePasswordModeChange = (value: boolean) => {
      setPasswordManual(value);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createSuperAdminMutation.mutateAsync({
        superAdmin: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
        },
      });
      showToast("New SuperAdmin Created", "success");
      navigate(ROUTES.EMC_MERRGE_SETTINGS.SUPERADMIN_USER_MANAGEMENT);
    } catch (error) {
      showToast("Failed to create Super Admin", "error");
    }
  };

  const passwordField = (
  <Field label="Password" required hint={passwordManual ? VALIDATION_MESSAGES.PASSWORD : ""}>
    <ButtonGroup
      name="password-mode"
      options={[
        { label: "Manual", value: true },
        { label: "Random", value: false },
      ]}
      onChange={handlePasswordModeChange}
      value={passwordManual}
      required
    />
    {passwordManual && (
      <>
        <Input
          className="password-input"
          autoComplete="new-password"
          name="new-password"
          value={formData.password}
          onChange={(e) => handleInputChange("password", e.target.value)}
          pattern={VALIDATION_PATTERNS.PASSWORD}
          title={VALIDATION_MESSAGES.PASSWORD}
          required
        />
      </>
    )}
  </Field>
);

  return (
    <SuperAdminForm
      title="Create New SuperAdmin"
      formData={formData}
      errors={errors}
      onChange={handleInputChange}
      onSubmit={handleSubmit}
      extraFieldsAfterEmail={passwordField} 
      actions={
        <>
          <Button
            type="submit"
            appearance="primary"
            disabled={createSuperAdminMutation.status === "pending"}
          >
            Create SuperAdmin
          </Button>
          <Button
            appearance="secondary"
            type="button"
            onClick={() => navigate(ROUTES.EMC_MERRGE_SETTINGS.SUPERADMIN_USER_MANAGEMENT)}
          >
            Cancel
          </Button>
        </>
      }
    />
  );
};

export default CreateSuperAdmin;
